import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ADD_SERVICE_PROVIDER_COORDINATOR_ICON } from "../../constants/constants";

@Component({
  selector: "im-service-provider-coordinator-dialog",
  templateUrl: "./service-provider-coordinator-dialog.component.html",
  styleUrl: "./service-provider-coordinator-dialog.component.scss",
  standalone: false,
})
export class ServiceProviderCoordinatorDialogComponent implements OnInit {
  public icon: string = ADD_SERVICE_PROVIDER_COORDINATOR_ICON;
  public title: string = "Assign to External Coordinator";
  public multiDropdownField = null;
  public multiDropdownControl = null;
  private serivceProviderCoordinators: string[];

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit(): void {
    this.multiDropdownField = this.data.section;
    this.multiDropdownControl = this.data.control;
  }

  public onSelectServiceProviderCoordinators(event: any): void {
    this.serivceProviderCoordinators = [];
    event.value.forEach((c) => this.serivceProviderCoordinators.push(c));
    if (this.serivceProviderCoordinators.length) this.data.section.valid = true;
    else this.data.section.valid = false;
  }

  public cancel() {
    this.dialogRef.close();
  }

  public assign() {
    this.dialogRef.close({
      data: {
        serviceProviderCoordinators: this.serivceProviderCoordinators,
      },
    });
  }
}
